export default __webpack_public_path__ + "static/media/plus.43a38a41.svg";